import { useCallback, useState } from 'react';

const usePopulationSelection = () => {
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [populationPopupState, setPopulationPopupState] = useState('pop');

    const handleLocationSelect = useCallback((feature) => {
        if (!feature || !feature.get('hjd_nm')) {
            setSelectedLocation(null);
            setPopulationPopupState('pop');
            return;
        }

        setSelectedLocation({
            hjdCd: feature.get('hjd_cd'),
            hjdNm: feature.get('hjd_nm'),
            popCnt: feature.get('pop_cnt'),
            popShare: feature.get('pop_share'),
            iPopCnt: feature.get('i_pop_cnt'),
            oPopCnt: feature.get('o_pop_cnt'),
            popRate: feature.get('pop_rate'),
            feature,
        });
        setPopulationPopupState('pop');
    }, []);

    return {
        selectedLocation,
        setSelectedLocation,
        populationPopupState,
        setPopulationPopupState,
        handleLocationSelect,
    };
};

export default usePopulationSelection;
